import { getConfiguration } from "./configuration";
import { getLocaleTimestamp } from "./getLocaleTimestamp";

export function getTimestampConformedUTC(timestamp) {
    const conf = getConfiguration();
    if (conf.dbutc) {
        return getLocaleTimestamp(timestamp);
    }else{
        return timestamp;
    }
}
